import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { QueryApiService } from 'src/app/shared/services/customer-api/query-api.service';
import { readSearchHandoff } from 'src/app/shared/utils/search-handoff';

/**
 * Guards the search route: restores the search query from the per-tab handoff
 * that the search launcher wrote, or bounces home if there is none.
 */
export const searchGuard: CanActivateFn = (next, state) => {
  const queryApi = inject(QueryApiService);
  const router = inject(Router);

  const stored = readSearchHandoff();
  if (stored) {
    queryApi.query = stored;
    if (!state.root.queryParams.id) {
      router.navigate([state.url.split('?')[0]], {
        queryParams: {
          id: Math.random(),
        },
        replaceUrl: true,
      });
    } else {
      return true;
    }
  } else {
    router.navigate(['/'], {
      replaceUrl: true,
    });
  }
};
